import { Box } from '@mui/material';
import { useContext } from 'react';

import AdminHeader from '@/components/admin/AdminHeader';
import AdminHome from '@/components/admin/AdminHome';
import { NotFound } from '@/components/NotFound';
import { UsersContext } from '@/Contexts/UsersContext';
import { UserType } from '@/models/User';

export default function Admin() {
  const { userType, admin } = useContext(UsersContext);

  if (!admin || userType !== UserType.Adf) {
    return <NotFound />;
  }

  return (
    <Box
      display='flex'
      flexDirection='column'
      height='100vh'
      width='100vw'
      sx={{
        overflowX: 'hidden',
      }}
    >
      <AdminHeader />
      <Box display='flex' flexDirection='column' flexGrow={1} overflow='auto'>
        <AdminHome />
      </Box>
    </Box>
  );
}
